<template>
    <div class="mainPageDiv">

        <h1 tabindex="0" class="pageHeader">
            Process Master List
        </h1>

        <table :id="'table_' + id" class="display compact" width="100%">
            <thead>
                <tr>
                    <th class="thLeft">Agency</th>
                    <th class="thLeft"> Authority </th>
                    <th class="thLeft">Contract Number</th>
                    <th class="thLeft">Company</th>
                    <th class="thCenter" title="View all individuals on the contract">Total</th>
                    <th class="thCenter" title="View all individuals in the NEW status">New</th>
                    <th class="thCenter" title="View all individuals in the HOLD status">Hold</th>
                    <th class="thCenter" title="View all individuals that require a Biometric Verification letter">BV</th>
                    <th class="thCenter" title="View all individuals in the QUALITY CONTROL status">QC</th>
                    <th class="thCenter" id="cmp" name="cmp" title="View all individuals in the COMPLETE status">Complete
                    </th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="pml in   pmllist  " :key="contractId">
                    <td tabindex="0" class="tdLeft">{{ pml.agencyName }}</td>
                    <td tabindex="0" class="tdLeft" style="white-space: nowrap">{{ pml.armingAuthorityAcronym }}</td>
                    <td tabindex="0" class="tdLeft" style="white-space: nowrap">{{ pml.contractNumber }}</td>
                    <td tabindex="0" class="tdLeft">{{ pml.companyName }}</td>
                    <td  class="tdCenter">
                        <a tabindex="0" herf="#" class="text-primary" @keydown.enter="TableAction('goToPersonsMaster', pml.contractId, pml.companyId)" @click="TableAction('goToPersonsMaster', pml.contractId, pml.companyId)">
                            {{
                                pml.pcnt
                            }}
                        </a>
                    </td>
                    <td class="tdCenter">
                        <div v-if="pml.new == null"><span tabindex="0">0</span></div>
                        <div v-else>
                            <a tabindex="0" herf="#" class="text-primary" @keydown.enter="TableAction('goToPersonsNew', pml.contractId, pml.companyId)" @click="TableAction('goToPersonsNew', pml.contractId, pml.companyId)">
                                {{
                                pml.new ?? 0
                                }}
                            </a>
                        </div>
                    </td>
                    <td class="tdCenter">
                        <div v-if="pml.holdCnt == null"><span tabindex="0">0</span></div>
                        <div v-else>
                            <a tabindex="0" herf="#" class="text-primary" @keydown.enter="TableAction('goToPersonsHold', pml.contractId, pml.companyId)" @click="TableAction('goToPersonsHold', pml.contractId, pml.companyId)">
                                {{
                                pml.holdCnt
                                }}
                            </a>
                            </div>
                    </td>
                    <td class="tdCenter">
                        <div v-if="pml.bvcnt == null"><span tabindex="0">0</span></div>
                        <div v-else>
                            <a tabindex="0" herf="#" class="text-primary" @keydown.enter="TableAction('bv', pml.contractId, pml.companyId)" @click="TableAction('bv', pml.contractId, pml.companyId)">
                                {{
                                pml.bvcnt
                                }}
                            </a>
                            </div>
                    </td>
                    <td class="tdCenter">
                        <div tabindex="0" v-if="showQC == 'Vendor'">
                            {{
                                pml.qccnt ?? 0
                            }}
                        </div>
                        <div v-else>
                                <a tabindex="0" herf="#" class="text-primary" @keydown.enter="TableAction('qc', pml.contractId, pml.companyId)" @click="TableAction('qc', pml.contractId, pml.companyId)">
                                    {{
                                    pml.qccnt ?? 0
                                    }}
                                </a>
                            </div>

</td>
                    <td class="tdCenter">
                        <a tabindex="0" herf="#" class="text-primary" @keydown.enter="TableAction('complete', pml.contractId, pml.companyId)" @click="TableAction('complete', pml.contractId, pml.companyId)">
                            {{
                                pml.completeCnt ?? 0
                            }}
                        </a>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="sum">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td tabindex="0" style="font-weight:bold;text-align:right;">TOTALS:</td>
                    <td tabindex="0" class="sum">{{ sumpcnt }}</td>
                    <td tabindex="0" class="sum">{{ sumnew }}</td>
                    <td tabindex="0" class="sum">{{ sumhold }}</td>
                    <td tabindex="0" class="sum">{{ sumbv }}</td>
                    <td tabindex="0" class="sum">{{ sumqc }}</td>
                    <td tabindex="0" class="sum">{{ sumcom }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import $ from "jquery";
import { store } from "@/store/store.js";
//import DataTableComponent from "@/components/dataSupport/DataTable.vue";
//import axios from "axios";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

export default {

    created() {

        this.dtSettings = {
            "searching": this.showSearch,
            "paging": false,
            "order": [this.orderColumnIndex, this.orderDirection.toString],
            "language": {
                "info": "Showing _START_ to _END_ of _TOTAL_ " + this.pluralDataName,
                "infoEmpty": "Showing 0 of 0 " + this.pluralDataName,
                "lengthMenu": "Show _MENU_ " + this.pluralDataName,
                "search": "Search " + this.pluralDataName + ":",
                "zeroRecords": this.pluralDataName != "" ? "No matching " + this.pluralDataName + " found." : "No matching records found.",
                "infoFiltered": "(filtered from _MAX_ total " + this.pluralDataName + ")",
            },
        };

        if (store.authenticatedUser.roleName == "Admin") {
            this.GetPMLUrl = store.webAPIUrl + "vwProcessMasterList";
        } else {
            this.UserProfileId = store.authenticatedUser.userProfileId
            this.GetPMLUrl = store.webAPIUrl + "vwProcessMasterList/" + this.UserProfileId;
        }

        fetch(this.GetPMLUrl)
            .then(res => res.json())
            .then(data => {
                let showQC = false  // ----- value to show/hide QC link by role ---- //
                this.pmllist = data

                //  ---- code to calculate and display column totals  -- //
                let pcntsum = 0
                let newsum = 0
                let holdsum = 0
                let bvsum = 0
                let qcsum = 0
                let comsum = 0
                for (let item = 0; item < this.pmllist.length; item++) {
                    pcntsum += this.pmllist[item].pcnt;
                    newsum += this.pmllist[item].new;
                    holdsum += this.pmllist[item].holdCnt;
                    bvsum += this.pmllist[item].bvcnt;
                    qcsum += this.pmllist[item].qccnt;
                    comsum += this.pmllist[item].completeCnt;
                }
                this.sumpcnt = pcntsum;
                this.sumnew = newsum;
                this.sumhold = holdsum;
                this.sumbv = bvsum;
                this.sumqc = qcsum;
                this.sumcom = comsum;
                //  ---- end code to calculate and display column totals  -- //

                this.showQC = store.authenticatedUser.roleName;  // ---- set the showQC value to user role ---- //
            })
            .catch(err => console.log(err.message));

        this.store.tempMasterPersonListResultsPerPage = 0;
    },

    data() {
        return {
            store,
            pmllist: [],
            dtSettings: {}, //ADDED DT SETTINGS TO DATA 
            dt: null, //ADDED DT OBJECT TO DATA
            id: "pmlTable", //***** ADDED TABLE ID SETTING HERE */
        }
    },

    props: {

        pluralDataName: {
            type: String,
            default: "Process Master List"
        },
        orderColumnIndex: {
            type: Number,
            default: 3,
        },
        orderDirection: {
            type: String,
            default: "asc",
        },
    },

    mounted() {

        //moved settings/ fetch to 'create'

    },

    methods: {

        TableAction(actionNameIdentifier, _contractId, _companyId) {
            //console.log(_companyId)
            store.tempContractId = _contractId;
            store.tempCompanyId = _companyId;

            switch (actionNameIdentifier) {
                case 'goToPersonsNew':

                    this.$router.push({ name: 'PersonsByContractNew', params: { contractId: _contractId } })
                    break;
                case 'bv':
                    alert('Open Biometric page list for contract ' + _contractId);
                    break;
                case 'qc':
                    this.$router.push({ name: 'PersonsByContractQC', params: { contractId: _contractId } })
                    break;
                case 'complete':
                    this.$router.push({ name: 'PersonsByContractComplete', params: { contractId: _contractId } })
                    break;
                case 'goToPersonsHold':
                    this.$router.push({ name: 'PersonsByContractHold', params: { contractId: _contractId } })
                    break;
                case 'goToPersonsMaster':
                    this.$router.push({ name: 'PersonsByContractMaster', params: { contractId: _contractId } })
                    break;
                default:
                    alert('Please select a contract and column to proceed');
            }
        }
    },
    watch: { //******** ADDED WATCH TO PMLLIST DATA TO PICKUP ON ANY DATA CHANGES TRIGGERING TABLE INITIALIZATION/DRAW */
        pmllist(val) {
            val;
            //console.log("loaded data changed");
            if (this.dt != null) { // destroys the datatable and resets TH widths to default
                this.dt.destroy();
                $("#table_" + this.id + " th").css('width', 'auto');
            }

            //console.log("setting up DT triggered by loadedData watch variable");
            //then render the new datatable using the initial settings:
            this.$nextTick(() => {
                //console.log(this.dtSettings);
                this.dt = $("#table_" + this.id).DataTable(this.dtSettings).draw();

            });
        },
    },

}


</script>

<style scoped>
.sum {
    text-align: center;
    font-size: 0.9em;
    min-width: 65px;
    font-weight: bold;
}

.tdLeft {
    text-align: left;
    font-size: 0.8em;
    min-width: 65px;
}

.tdCenter {
    text-align: center;
    font-size: 0.8em;
    min-width: 65px;
}


.thCenter {
    font-size: 12px !important;
    max-width: 400px;
    text-align: center !important;
}

.thLeft {
    font-size: 12px !important;
    max-width: 400px;
    text-align: left !important;
}

:slotted(th) {
    min-width: 50px !important;
    font-size: 12px !important;
    text-align: center !important;
}

:slotted(.actionColumn) {
    min-width: 120px;
}

:slotted(.forIconEdit) {
    margin-right: 15px;
}

.tableContainerLucas {
    width: 100%;
}

.dataTables_wrapper .dataTables_filter input {
    background-color: white;
    opacity: 85%;
}
</style>
  
